import { LegalEntityAuditGroupAuditModel } from "../../legalEntityAuditGroupOverview/LegalEntityAuditGroupOverview.types";
import { useTranslation } from "../../../localization/useTranslation";
import { ManagementReportInProgressAuditsProps } from "./ManagementReportInProgressAudits";
import { useStateUrlParamsArray } from "../../../common/hooks/useStateUrlParams";
import { useDownloadLegalEntityAuditReport } from "../../DowloadLegalEntityAuditReport.hooks";
import { filterBySelection, toSelectOptions } from "@common/components/managementReport/managementReportFilters";

export function useManagementReportInProgressAudits(props: ManagementReportInProgressAuditsProps) {
    const [searchedStatus, setSearchedStatus] = useStateUrlParamsArray("status", []);
    const [searchedRemindersSent, setSearchedRemindersSent] = useStateUrlParamsArray("remindersSent", []);

    const { translateDate, translateLegalEntityAuditStatus } = useTranslation();
    const { onDownloadReportAsPdf, getReportPdfUrl, isDownloadingPdf } = useDownloadLegalEntityAuditReport();

    const audits: Array<LegalEntityAuditGroupAuditModel> = props.audits ?? [];

    const statusFilterOptions = toSelectOptions(
        audits.map((audit) => ({ id: audit.status.toString(), name: translateLegalEntityAuditStatus(audit.status.toString()) }))
    );
    const remindersSentFilterOptions = toSelectOptions(audits.map((audit) => toReminderSentOption(audit.reminderSent)));

    let filteredRows = filterBySelection(audits, searchedStatus, (row) => row.status.toString());
    filteredRows = filterBySelection(filteredRows, searchedRemindersSent, (row) => toReminderSentOption(row.reminderSent)?.id);

    function toReminderSentOption(reminderSent: Date | null) {
        if (reminderSent === null) {
            return undefined;
        }

        const sent = new Date(reminderSent);

        return { id: sent.getTime().toString(), name: translateDate(sent) };
    }

    return {
        rows: filteredRows,
        isDownloadingPdf,
        statusFilterOptions,
        searchedStatus,
        onDownloadReportAsPdf,
        getReportPdfUrl,
        setSearchedStatus,
        searchedRemindersSent,
        setSearchedRemindersSent,
        remindersSentFilterOptions,
    };
}
